import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import DropzoneWrapperDocuments from "./DropzoneWrapperDocuments";
import ErrorWrap from "./error-success/ErrorWrap";

// State
import { userLogout } from "../../store/actions/user";

// Utils
import ChunkUploader from "../../utils/ChunkUploader";

/*
 * Prop notes
 * - loading={bool}         // If this component should begin it's upload process
 * - clear={bool}           // If this component should clear it's state.  Usually happens once there is a successfull upload by parent
 * - type={string}          // Type of asset component will be uploading (mobile/full/etc)
 * - uploadAssetType={string} // Type of asset we are uploading.  This is passed to the API to ensure upload is uploaded to correct location
 * - addPromise={promise}   // Return the promise of the upload process to the parent
 * - allowMultiple={false}  // Allow multiple images to be within the uploader.  If false, only one file can be present at any time.
 * - error={string}         // A specific error passed back by the parent (usually if the record or some data is crap on the main parent's update)
 * - token={string}         // (Optional) The token to use for the upload process.  If not set, the admin token will attempt to be used
 */

class DocumentsUploader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			img: [],
			error: "",
			token: !!props.token ? props.token : "",
			uploadPromises: []
		};
	}

	componentWillReceiveProps(nextProps) {
		// If the submit button was pressed
		if (nextProps.loading === true && this.props.loading !== nextProps.loading) {
			this.uploadStart();
		}

		// Loading has ended (error or something in parent)
		if (nextProps.loading === false && this.props.loading !== nextProps.loading) {
			this.setState({
				img: this.state.img.map(img => {
					let updatedImg = img;
					updatedImg.loading = false;
					updatedImg.completed = 0;
					updatedImg.message = "";
					return updatedImg;
				})
			});
		}

		// If submit was completed, clear the state
		if (nextProps.clear && this.props.clear !== nextProps.clear) {
			this.clearState();
		}

		if (!!nextProps.error && nextProps.error !== "") {
			this.setState({
				error: nextProps.error
			});
		}
	}

	clearState() {
		this.setState({
			img: [],
			error: "",
			token: ""
		});
	}

	clearCurrentFiles = () => {
		this.setState({
			img: []
		});
	};

	handleImgUpdate = (name, file) => {
		this.setState(
			{
				img: this.props.allowMultiple ? [...this.state.img, file] : [file]
			},
			() => {
				// If the parent component wants to do something when the image is updated, then go for it
				if (this.props.handleParentImgUpdate) {
					this.props.handleParentImgUpdate(this.state.img);
				}
			}
		);
	};

	handleImgRemoval = files => {
		this.setState({
			img: files
		});
	};

	handleUploadProgress = (imageIndex, percentage = "", message = "") => {
		this.setState({
			img: this.state.img.map((item, index) => {
				if (index !== imageIndex) return item;

				let imgItem = item;
				imgItem.completed = percentage;
				imgItem.message = !message ? percentage + "%" : message;

				return imgItem;
			})
		});
	};

	updateUploadToken(token) {
		this.setState({
			token
		});
	}

	uploadStart() {
		const token = this.state.token !== "" ? this.state.token : this.props.user.token;

		// Reset all errors, etc
		this.setState(
			{
				error: ""
			},
			() => {
				// Begin upload process
				this.props.addPromise(
					new Promise((resolve, reject) => {
						// Get data from state
						const { img, uploadPromises } = this.state;

						// Image is null, do nothing
						if (!img.length) {
							return resolve(null);
						}

						// Loop through all images
						img.forEach((imgItem, imageIndex) => {
							// ===================================
							//  Add a promise to the parent
							// ===================================
							uploadPromises.push(
								new Promise((resolve, reject) => {
									// Set the file to loading
									this.setState(
										{
											img: this.state.img.map((item, index) => {
												if (index !== imageIndex) return item;
												imgItem.loading = true;
												return imgItem;
											})
										},
										() => {
											// Is Nonce, or straight admin...?
											const isNonce = this.props.isNonce
												? this.props.isNonce
												: false;

											// Initialize chunk uploader
											let uploader = new ChunkUploader(isNonce);

											// Begin upload
											return uploader
												.uploadFile(
													this.props.uploadAssetType,
													imgItem,
													token,
													this.updateUploadToken.bind(this),
													imageIndex,
													this.handleUploadProgress.bind(this)
												)
												.then(res => {
													// Send back a resolved object with any manually set info (alt, link, etc)
													return resolve({
														type: !!this.props.type
															? this.props.type
															: null,
														results: {
															...res
														}
													});
												})
												.catch(err => {
													console.log("Error uploading:", err);

													// Check user token
													if (err.obj.data.status === 403) {
														this.props.userLogout("admin");
													}

													this.setState({
														error: err.error
													});

													return reject(err.error);
												});
										}
									);
								})
							);
						});

						// ===================================
						//  Done all uploads, let's reset some stuff and resolve them
						// ===================================
						return Promise.all(uploadPromises)
							.then(res => {
								this.setState({
									uploadPromises: [],
									token: !!this.props.token ? this.props.token : ""
								});
								return resolve(res);
							})
							.catch(err => {
								this.setState({
									uploadPromises: [],
									error: err,
									token: !!this.props.token ? this.props.token : ""
								});
								return reject(err);
							});
					})
				);
			}
		);
	}

	render() {
		const { placeholder } = this.props;
		const { img, error } = this.state;

		return (
			<div className="dropzone-documents">
				{!!error && <ErrorWrap animate={1}>{error}</ErrorWrap>}
				<DropzoneWrapperDocuments
					img={img}
					placeholder={placeholder}
					handleFileUpdate={this.handleImgUpdate}
					handleFileRemoval={this.handleImgRemoval}
					multiple={this.props.allowMultiple}
					clearCurrentFiles={this.clearCurrentFiles}
					{...this.props}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(
	mapStateToProps,
	{ userLogout }
)(DocumentsUploader);



// WEBPACK FOOTER //
// ./src/components/utils/DocumentsUploader.js